import { toast } from "react-toastify";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setSuccessMessage } from "../../toastMessage/action";
import { GET_STATION_USAGE_API, GET_STATION_USAGE_TREND_API } from "../../constants/constants";
import { fetchStationUsageTrendFailure, fetchStationUsageTrendSuccess } from "./reducer";

export const getAllStationUsageTrend =
  (stationId, setLoading, dateRange) => async (dispatch) => {
    setLoading(true);

    const periodMap = {
      "1m": "month",
      "3m": "3month",
      "6m": "6month",
      "12m": "year",
    };

    const periodValue =
      dateRange?.period === "custom"
        ? "week"
        : periodMap[dateRange?.period] || "3month";

    const url = `${GET_STATION_USAGE_TREND_API}/${stationId}?unit=Wh&period=${periodValue}${
      dateRange?.period === "custom"
        ? `&from=${dateRange?.from}&to=${dateRange?.to}`
        : ""
    }`;

    await determineBaseUrlAndPerformApiCall(url, "GET")
      .then((response) => {
        setLoading(false);
        if (response === null || response === undefined) {
          dispatch(fetchStationUsageTrendSuccess([]));
          return;
        }
        if (!response.error) {
          dispatch(fetchStationUsageTrendSuccess(response || []));
        }
        if (response.error) {
          if (response.error.code === "NotFound") {
            dispatch(fetchStationUsageTrendSuccess([]));
          } else {
            dispatch(fetchStationUsageTrendFailure(response.error.message));
            toast.error(`${response.error.message}`);
          }
        }
      })
      .catch(() => {});
  };
